module.exports = __webpack_public_path__ + "static/media/carroseg.ad411e5f.png";